import ActivityHistoryNudgeBg from "@common/assets/images/details-pane-icons/nudge/activity-history-nudge-bg.png";
import IntegrationsNudgeBg from "@common/assets/images/details-pane-icons/nudge/integrations-nudge-bg.png";
import MetadataNudgeBg from "@common/assets/images/details-pane-icons/nudge/metadata-nudge-bg.png";
import SentryNudgeBg from "@common/assets/images/details-pane-icons/nudge/sentry-nudge-bg.png";
import UserDetailsNudgeBg from "@common/assets/images/details-pane-icons/nudge/user-details-nudge-bg.png";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import { rgba } from "polished";
import styled from "styled-components";

export const Nudge = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  padding: 2rem;
  border: 0.15rem solid ${rgba(vars.colors.sky, 0.15)};
  border-radius: 1rem;
`;

export const ActivityHistoryNudge = styled(Nudge)`
  height: 14rem;
  max-width: 41.6rem;

  background-image: url(${ActivityHistoryNudgeBg});
  background-size: auto 14.3rem;
  background-position-x: -0.2rem;
  background-repeat: repeat;
`;

export const IntegrationsNudge = styled(Nudge)`
  height: 14rem;
  max-width: 41.6rem;

  background-image: url(${IntegrationsNudgeBg});
  background-size: auto 14.3rem;
  background-position-x: -0.2rem;
  background-repeat: repeat;
`;

export const MetadataNudge = styled(Nudge)`
  height: 14rem;
  max-width: 41.6rem;

  background-image: url(${MetadataNudgeBg});
  background-size: auto 14.3rem;
  background-position-x: -0.2rem;
  background-repeat: repeat;
`;

export const UserDetailsNudge = styled(Nudge)`
  height: 14rem;
  max-width: 41.6rem;

  background-image: url(${UserDetailsNudgeBg});
  background-size: auto 14.3rem;
  background-position-x: -0.2rem;
  background-repeat: repeat;
`;

export const SentryNudge = styled(Nudge)`
  flex: 0 0 10.3rem;
  max-width: 54rem;

  background-image: url(${SentryNudgeBg});
  background-size: auto 10.6rem;
  background-position-x: -0.2rem;
  background-repeat: repeat;

  margin-bottom: 4rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const NudgeContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 1rem;
`;

export const NudgeTitleDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-bottom: 1rem;
`;

export const NudgeButtonDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NudgeTitleIcon = styled.img`
  margin-right: 1rem;
`;

export const NudgeTitle = styled(Paragraph)`
  color: ${vars.colors.sky};
`;

export const NudgeText = styled(Paragraph)`
  display: flex;
  height: 100%;
  flex-direction: column;
  cursor: default;
  color: ${vars.colors.grey30};
`;
